import type { Id, Doc } from "../../../../convex/_generated/dataModel";

export type Evaluation = Doc<"evaluations">;

// Embedded types from schema (not tables, so not in Doc<>)
export type DonneesEntStruct = Extract<
  Evaluation["donnees"],
  { type: "ent-struct" }
>;
export type EntStructEvaluation = Omit<Evaluation, "donnees"> & {
  donnees: DonneesEntStruct;
};

// ============================================
// TYPES SPÉCIFIQUES INBASKET
// ============================================

// Réponses aux mails (structure dans donnees.reponses)
export type EntStructReponses = DonneesEntStruct["reponses"];
export type EntStructReponse = EntStructReponses[string];

export type MessageRole = "assistant" | "user";

// ============================================
// GESTION D'ERREURS (identique à form)
// ============================================

/**
 * Type pour les réponses d'erreur du backend
 */
export interface BackendError {
  erreur: string;
  bloqueJusquA?: number;
}

/**
 * Résultat d'une query/mutation qui peut échouer
 */
export type BackendResult<T> = T | BackendError;

/**
 * Type guard pour vérifier si c'est une erreur
 */
export function isBackendError(result: unknown): result is BackendError {
  return (
    typeof result === "object" &&
    result !== null &&
    "erreur" in result &&
    typeof (result as BackendError).erreur === "string"
  );
}
